module.exports = __webpack_public_path__ + "static/img/img-jstd.852a8ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-jstd.png
// module id = 438
// module chunks = 2